import PropTypes from 'prop-types'
import { Fragment } from 'react'

import Content from 'components/common/Content'
import Subnav, { SubnavLink } from 'components/navigation/Subnav'

const SchedulesLayout = ({ hideSubnav, ...props }) => {
  return (
    <Fragment>
      {!hideSubnav && (
        <Subnav>
          <SubnavLink
            data-track-action="open-attack-schedules"
            data-track-category="sub-navigation"
            data-track-on="click"
            text="Attacks"
            to="/schedules/attacks"
          />
          <SubnavLink
            data-track-action="open-scenario-schedules"
            data-track-category="sub-navigation"
            data-track-on="click"
            text="Scenarios"
            to="/schedules/scenarios"
          />
        </Subnav>
      )}
      <Content {...props} />
    </Fragment>
  )
}

SchedulesLayout.propTypes = {
  hideSubnav: PropTypes.bool
}

export default SchedulesLayout
